module.exports = __webpack_public_path__ + "img/wholesaleBanner.b9dbfe83.png";